import React from "react";
import s from "./Card.module.scss";

const cx = (...a) => a.filter(Boolean).join(" ");

/**
 * Card — универсальный контейнер.
 * Внутри используем подкомпоненты Card.Media / Card.Header / Card.Body / Card.Footer и т.д.
 */
export default function Card({
  as: Tag = "div",
  href,
  onClick,
  children,
  className,
  variant = "default", // default | outline | ghost | dark
  padding = "md",      // sm | md | lg
  radius = "lg",       // md | lg | xl
  hover = true,
  ...rest
}) {
  const classes = cx(
    s.card,
    s[`v_${variant}`],
    s[`p_${padding}`],
    s[`r_${radius}`],
    hover && s.hover,
    className
  );

  const props = { className: classes, onClick, ...rest };

  // если карточка кликабельная как ссылка
  if (Tag === "a") {
    props.href = href;
    // не ставим target по умолчанию, чтобы не ломать поведение
  }

  return <Tag {...props}>{children}</Tag>;
}

/* ========= Подкомпоненты ========= */

Card.Media = function CardMedia({ src, alt = "", overlay = false, className }) {
  // overlay=true если хочешь затемнение под текстом
  return (
    <div className={cx(s.media, className)}>
      <img className={s.mediaImg} src={src} alt={alt} loading="lazy" />
      {overlay && <div className={s.mediaOverlay} />}
    </div>
  );
};

Card.Header = function CardHeader({ children, className }) {
  return <div className={cx(s.header, className)}>{children}</div>;
};

Card.Body = function CardBody({ children, className }) {
  return <div className={cx(s.body, className)}>{children}</div>;
};

Card.Footer = function CardFooter({ children, className }) {
  return <div className={cx(s.footer, className)}>{children}</div>;
};

Card.Title = function CardTitle({ children, className }) {
  return <h3 className={cx(s.title, className)}>{children}</h3>;
};

Card.Text = function CardText({ children, className }) {
  return <p className={cx(s.text, className)}>{children}</p>;
};

Card.Icon = function CardIcon({ children, className }) {
  // children = <svg> или <img>
  return <div className={cx(s.icon, className)}>{children}</div>;
};

Card.Badge = function CardBadge({ children, className }) {
  return <div className={cx(s.badge, className)}>{children}</div>;
};

Card.Price = function CardPrice({ children, className }) {
  return <div className={cx(s.price, className)}>{children}</div>;
};

Card.Actions = function CardActions({ children, className }) {
  return <div className={cx(s.actions, className)}>{children}</div>;
};

Card.Button = function CardButton({
  as: Tag = "button",
  children,
  className,
  variant = "primary", // primary | secondary | ghost
  ...rest
}) {
  return (
    <Tag className={cx(s.btn, s[`btn_${variant}`], className)} {...rest}>
      {children}
    </Tag>
  );
};
